<template>
    <time :datetime="date.toISOString()" :title="formatDateTimeMedium(date)">{{ timeAgo }}</time>
</template>

<script setup lang="ts">
import { useTimeAgoIntl } from "@vueuse/core";
import { formatDateTimeMedium } from "@/dateTimeUtils";

type Props = {
    date: Date;
};

const props = defineProps<Props>();

const timeAgo = useTimeAgoIntl(() => props.date);
</script>
